import { render, staticRenderFns } from "./srvProjectDialog.vue?vue&type=template&id=2d0e788f&scoped=true&"
import script from "./srvProjectDialog.vue?vue&type=script&lang=js&"
export * from "./srvProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e788f",
  null
  
)

export default component.exports